import React, { useEffect, useState } from 'react'
import MySelect from '../../../../../../UI/form/MySelect'

const DeliveryStatusSelect = ({ required, setValidate, setValueForm, forciblyValue }) => {

	// console.log('forciblyValue', forciblyValue)

  	const [value, setValue] = useState(
		forciblyValue && forciblyValue === true ? 'yes' :
		forciblyValue === false ? 'no' : forciblyValue
	)
	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'created',
			name: 'Створено'
		},
		{
			id: 'deliver',
			name: 'Доставляється'
		},
		{
			id: 'delivered',
			name: 'Доставлено'
		},
	])

	// useEffect(() => {
	// 	getUnitMeasures()
	// }, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getUnitMeasures = () => {
		// getGoodTypesAllAPI().then(data => {
		// 	setGoodTypes(data)
		// }).catch(e => {
		// 	// setError(responseError(e))
		// 	console.error(responseError(e))
		// })
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Статус доставки"
        labelId="select__deliveryStatus-label"
        id='select__deliveryStatus'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Статус доставки'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default DeliveryStatusSelect